import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useRootStore } from 'stores/RootStore'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

export const useCampaignsFeatureFlag = () => {
  const workspace = useCurrentWorkspace()
  const { currentSubscription } = useRootStore().tierUsageStore

  const isOnStarterPlan = currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotStarter
  const isOnGrowthPlan = currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotGrowth

  return workspace?.is_campaigns || isOnStarterPlan || isOnGrowthPlan
}
